import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Select } from "@mui/material";
import { combineSxProps } from "../../Utils";
export const NoOutlineSelect = React.forwardRef((props, ref) => {
    return _jsx(Select, Object.assign({ ref: ref }, props, { variant: "standard", disableUnderline: true, sx: combineSxProps(selectSxProps, props.sx) }));
});
const selectSxProps = {
    cursor: "default",
    "& .MuiSelect-standard": {
        "&:focus": {
            backgroundColor: "transparent"
        }
    },
    ":hover:not(.Mui-disabled)": {
        backgroundColor: theme => theme.palette.action.hover,
        color: theme => theme.palette.primary.main,
        borderRadius: "100px",
        "& .MuiSelect-icon": {
            fill: theme => theme.palette.primary.main
        }
    },
    fontSize: "14px",
    lineHeight: "24px",
    color: theme => theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    padding: "4px 16px",
    "& .MuiInput-input": {
        padding: "unset",
        "&.Mui-disabled": {
            color: theme => theme.palette.text.primary
        }
    },
    ".MuiSelect-icon": {
        right: "16px",
        fill: theme => theme.palette.text.secondary,
        "&.Mui-disabled": {
            fill: theme => theme.palette.action.disabled
        }
    },
    "&.MuiInputBase-sizeSmall": {
        padding: "4px",
        ".MuiSelect-icon": {
            right: "4px"
        }
    },
    "&.MuiInputBase-root": {
        borderRadius: "100px"
    }
};
//# sourceMappingURL=NoOutlineSelect.js.map